import React, { Component } from 'react';
import './page-title.css';

export default class PageTitle extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <h3 className="rdp-react-template-component-page-title">
        {this.props.label}
      </h3>
    );
  }
}
